const replaceUrlCssFontFaceRule = (rule: CSSFontFaceRule) => {
  if (!rule.style.cssText) {
    return false;
  }

  let urlMatch = null;
  const matchUrl = rule.style.cssText.match(/url\(.*?\)/g);

  if (matchUrl && matchUrl.length > 0) {
    urlMatch = matchUrl[0];
  }

  const src = rule.style.getPropertyValue('src') || urlMatch;

  if (!src) {
    return null;
  }

  const url = src
    .split('url(')[1]
    .split(')')[0]
    .replace(/"/g, '');

  return {
    rule: rule,
    src: src,
    url
  };
};

export const fontUrlToDataBase6Uri = async (url: string): Promise<any> => {
  try {
    const resp = await fetch(url);
    const text = await resp.text();

    const styleElement = document.createElement('style');
    styleElement.innerHTML = text;
    document.head.appendChild(styleElement);

    const styleSheet = styleElement.sheet as CSSStyleSheet;
    if (!styleSheet) {
      return false;
    }

    let fontRules = [];
    let fontProms = [];

    for (let index = 0; index < styleSheet.cssRules.length; index++) {
      const fontRule = styleSheet.cssRules[index] as CSSFontFaceRule;
      const cssFontFaceRule = replaceUrlCssFontFaceRule(fontRule);

      if (!cssFontFaceRule) {
        continue;
      }

      fontRules.push(cssFontFaceRule);
      fontProms.push(
        fetch(cssFontFaceRule.url)
          .then(resp => resp.blob())
          .then(blob => {
            return new Promise(resolve => {
              let fileReader = new FileReader();
              fileReader.onload = () => resolve(fileReader.result);
              fileReader.readAsDataURL(blob);
            });
          })
          .then(dataURL => {
            const stringDataUrl = dataURL as string;
            return cssFontFaceRule.rule.cssText.replace(
              cssFontFaceRule.url,
              stringDataUrl
            );
          })
      );
    }
    document.head.removeChild(styleElement);
    return Promise.all(fontProms);
  } catch (error) {
    return false;
  }
};
